<template>
    <div class="shop shop_category">
        <div class="shop_header">
            <div class="shop_header-back" @click="this.$router.go(-1)">
                <img src="../assets/img/arrow.svg" alt="">
            </div>
            {{this.$route.query.categoryName}}
        </div>
        <div class="shop_category_filter-section">
            <shop-category-filter/>
        </div>

        <div class="shop_items-section">
            <shop-items/>
        </div>
    </div>
</template>

<script>
    import ShopCategoryFilter from "../components/shop/ShopCategoryFilter";
    import ShopItems from "../components/shop/ShopItems";

    export default {
        name: 'ShopCategory',
        components: {ShopCategoryFilter, ShopItems},
    }
</script>
